<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="Relatórios Personalizados"
          page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/global/exam.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <a *ngIf="podeIncluir()" [routerLink]="['/relatorios-personalizados/novo']"
          class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 pt-2">
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
      <div class="offset-2 col-5" style="text-align: right" *ngIf="lista && lista.length > 0">
        <span class="mr-1">{{paginaCorrente}} de</span>
        <span class="ml-1">{{paginaTotal}} </span>
        <a style="cursor: pointer" (click)="paginaAnterior()" aria-label="Previous" class="mr-3 ml-2">
          <img src="assets/img/global/left-24.png" alt="anterior" height="20" width="20">
        </a>
        <a style="cursor: pointer" (click)="proximaPagina()" aria-label="Next" class="ml-1">
          <img src="assets/img/global/right-24.png" alt="próximo" height="20" width="20">
        </a>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-md-4" *ngFor="let item of lista" style="padding: 10px;">
        <div class="card card-contrast">
          <div class="card-header card-header-contrast card-header-featured">
            {{item.nome}}
          </div>
          <div class="card-body" style="padding: 5px 10px;">
            <p *ngIf="item.descricao">
              <small>{{item.descricao}}</small>
            </p>
            <p class="m-0">
              <small>Criado por {{item.usuario.nome}} em {{item.data_cadastro | date:'dd/MM/yyyy HH:mm'}}</small>
            </p>
            <p class="m-0">
              <small>Última atualização: {{item.data_alteracao | date:'dd/MM/yyyy HH:mm'}}</small>
            </p>
          </div>
          <div class="card-footer">
            <button [routerLink]="['/relatorios-personalizados', item.id, 'visualizar']"
              routerLinkActive="router-link-active" class="btn btn-sm btn-success">
              <i class="fa fa-play"></i> Executar Relatório
            </button>
            <button *ngIf="podeIncluir() && item.usuario.id === login.usuario.id" (click)="remover(item)"
              class="btn btn-sm btn-outline-danger float-right ml-2">
              <img src="assets/img/global/cross.png" alt="" height="16" width="16">
            </button>
            <button *ngIf="podeIncluir()" [routerLink]="['/relatorios-personalizados', item.id, 'editar']"
              routerLinkActive="router-link-active" class="btn btn-sm btn-outline-primary float-right">
              <img src="assets/img/global/pencil.png" alt="" height="16" width="16">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog [style]="{width: '40vw'}"></p-confirmDialog>